export const FETCH_PAYMENT_TYPES = "fetch_payment_types";
export const FETCH_PAYMENT_TYPES_SUCCESS = "fetch_payment_types_success";